import React, { useEffect, useState } from 'react';
import { Link } from 'react-router';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { SingleOrMultiUser } from './steps/SingleOrMultiUser';
import { UserAndAccess } from './steps/UserAndAccess';
import { DelegationLog } from './steps/DelegationLog';
import { AddDocumentToBinderLogOptions, AddToDelegationLogOptions, AddingUserOptions } from './constants';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faExternalLink, faClose } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import uuid from 'uuid';

import { Box } from '@material-ui/core';
import {
    delegationsList,
    getDelegationTaskOptions,
} from 'pages/delegationOfAuthority/selectors';

// @ts-ignore
import styles from './styles.scss';

import { Conditional } from 'common/components/layout';
import { getMultiUserListOptions, getTeamMemberSelection } from '../../containers/StudySettings/Settings/utils/selectors';
import { manageAdminsPredicate, manageStudyDelegationPredicate, manageStudyTeamMemberPredicate } from 'common/permissions/studyPredicates';
import {
    addStudyTeamMember,
    createTeamMember,
    editStudyTeamMember,
    getStudyDescriptors,
    getStudyRoles,
    getTeamMembersByInstitution,
    removeStudyTeamMember,
    unloadStudySettingsTeam,
    getAllUsers,
    loadExternalUsersForStudy
} from 'pages/studyOverview/actions/studySettings';
import { modifyStudyTeamMember } from 'pages/studyOverview/actions/studySettingsStudyTeam';
import { loadStudyTasksV2 } from 'pages/delegationOfAuthority/v2/actions/studyTasksV2';
import { loadStudyDelegationsV2, deleteStudyDelegationV2 } from 'pages/delegationOfAuthority/v2/actions/studyDelegationsV2';

import lodash from 'lodash';

import './types';
import { STUDY_USER_TYPE, STUDY_TEAM_DESC, STUDY_TEAM_CAPITAL_v2 } from 'components/common/Study/StudyTeamMemberForm/index';
import { BUTTON, Button } from '../../../../components/common/Button/Button';
import {
    loadDataSource,
    unloadDataSource,
    saveDataSource,
    writeDataSourceValues,
    loadDataSourceLog,
} from 'pages/dataSource/actions/dataSource';
import {
    updateStudyDelegationV2,
} from 'pages/delegationOfAuthority/v2/actions/studyDelegationsV2';
import { convertToISOString } from '../../../../common/util/dateTime';
import { getActivePI } from '../../../delegationOfAuthority/selectors/index';
import { isPITenureOverlappingWithDelegation } from '../../../delegationOfAuthority/util/predicates';
import Input from '../../../../components/common/Input/FormInput';
import { verifyNoPITenuresOverlapped } from 'pages/delegationOfAuthority/v2/util/validators';
import { loadHomePageV4Access } from '../../../../common/features/predicates';
import { SpinnerMini } from '../../../../components/common/LoadingStatus/LoadingStatus';
/**
 * Steps names.
 */
const FormStepsEnum = {
    initial: 'initial',
    userAndAccess: 'userAndAccess',
    delegationLog: 'delegationLog',
    addUserDatasourceToStudy: 'addUserDatasourceToStudy',
};

// Overrides Material UI components
const AddUsersModalStyles = makeStyles({
    nextBtn: {
        backgroundColor: '#F1913B',
        textTransform: 'capitalize',
        border: 'none',
        fontSize: '16px',
        fontWeight: 600,
        color: 'white',
        marginLeft: '1rem',
        '&:hover': {
            backgroundColor: '#F1913B',
            color: 'white',
        },
        maxHeight: '41px'
    },
    secondaryBtn: {
        textTransform: 'capitalize',
        border: '2px solid #B1B1B1',
        color: '#28282E',
        fontSize: '16px',
        fontWeight: 600,
        padding: '11px 10px 11px 10px',
        maxHeight: '41px'

    },
    secondaryConfirmationBtn: {
        textTransform: 'capitalize',
        borderRadius: '3px',
        border: '2px solid var(--grey-600, #B1B1B1)',
        color: '#28282E',
        fontSize: '16px',
        fontWeight: 600,
        width: '100%',
        maxHeight: '41px'

    },
    removeBtn: {
        fontSize: '16px',
        fontWeight: 600,
        border: '2px solid #CC3333',
        color: '#CC3333',
        padding: '11px 10px 11px 10px',
        '&:hover': {
            borderColor: '#CC3333',
        },
        maxHeight: '41px'

    },
    primaryBtn: {
        textTransform: 'capitalize',
        fontSize: '16px',
        fontWeight: 600,
        padding: '11px 10px 11px 10px',
        minWidth: '89px',
        maxHeight: '41px'
    },
    backDrop: {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
    paper: {
        width: 'auto',
        boxShadow: '-5px 0px 5px 0px rgba(0, 0, 0, 0.25) !important'
    },
    addUserBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#1956a7',
        border: 'none',
        color: 'white',
        fontSize: '16px',
        fontWeight: '600',
        padding: '8.5px',
        textTransform: 'capitalize',
        '&:hover': {
            backgroundColor: '#1956a7',
            color: 'white',
        },
        '&:active': {
            outline: 'none',
        }
    }
});
const PI_ROLE = 'Principal Investigator';
const parseDateFormat = (date) => {
    if (lodash.isNil(date)) {
        return null;
    }

    return moment.utc(date);
};
/**
 * Use to display a modal on the Users tab on studies
 * for the client to add a single user or multiple users to the
 * current study.
 * 
 * @param {UsersModalProps} props
 */
export function AddUsersModal(props) {
    const [drawerState, setDrawerState] = useState(false);
    const [userBeingAdded, setUserBeingAdded] = useState(undefined);
    const [currentFormStep, setCurrentFormStep] = useState([FormStepsEnum.initial]);
    const [singleOrMulti, setSingleOrMulti] = useState(AddingUserOptions.single);
    const [isEditMode, setIsEditMode] = useState(false);
    const [selectedUser, setSelectedUser] = useState();
    const [showRemoveStudy, setShowRemoveStudy] = useState(false);
    const [showAdminRemoveStudy, setShowAdminRemoveStudy] = useState(false);
    const [showRemoveStudyAudit, setShowRemoveStudyAudit] = useState(false);
    const [auditNote, setAuditNote] = useState('');
    const [endDate, setEndDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
    const [isRequiredNote, setRequiredNote] = useState(false);
    const [studyAdminCount, setStudyAdminCount] = useState(0);
    const [currentAccessLevel, setCurrentAccessLevel] = useState('');
    const [loading, setLoading] = useState(false);


    const [studyAccessLevel, setStudyAccessLevel] = useState({
        user: undefined,
        access: undefined,
        users: undefined
    });
    const [delegationState, setDelegationState] = useState();
    const initialError = {
        user: false,
        access: false,
        dataSource: false,
        role: false,
        auditNote: false,
        endDate: false

    };
    const [errorState, setErrorState] = useState(initialError);
    const classes = AddUsersModalStyles();

    const [delegationRequiringNewPISignature, setDelegationRequiringNewPiSignature] = useState([]);

    const [PIsignatureError, setPISignationError] = useState(false);

    useEffect(() => {

        props.getStudyRoles(props.study.institutionId);
        props.getTeamMembersByInstitution(props.study.institutionId);
        props.getStudyDescriptors(props.study.institutionId, props.study.studyTypeId);
        props.loadStudyTasksV2(props.study.binderId, props.study.id);
        props.loadStudyDelegationsV2(props.study.binderId, props.study.id);
        props.getAllUsers();
        props.loadExternalUsersForStudy(props.study.binderId, props.study.institutionId, {});

    }, []);

    useEffect(() => {
        if (props.dismiss)
            setDrawerState(props.dismiss);
    }, [props.dismiss]);

    useEffect(() => {
        if (props.dataSourceId)
            props.loadDataSource(props.dataSourceId);
    }, [props.dataSourceId]);

    useEffect(() => {
        if (props.selectedRow) {
            setDrawerState(true);

            const selectedObject = {
                access: {
                    label: `${props.selectedRow.userType}`,
                    value: lodash.lowerCase(props.selectedRow.studyUserType),
                },
                user: {
                    value: props.selectedRow.id,
                    label: props.selectedRow.teamMemberName,
                    sub: props.selectedRow.sub,
                }
            };
            handleOnUserAndAccessSelectedEdit(selectedObject);
            setIsEditMode(true);
            setSelectedUser(props.selectedRow.selectedUser);
        }
    }, [props.selectedRow]);

    useEffect(() => {
        if (isEditMode) {
            setStudyAdminCount(props.studyAdminCount);
            setCurrentAccessLevel(props.selectedRow.studyUserType);
        }
    }, [props.allStudyTeamMembers]);

    /**
     * Toggle on/off the drawer(modal).
     * Also cleans up the other states when the drawer is closed.
     */
    const toggleDrawer = () => {
        setDrawerState(!drawerState);

        // Clean up states when we close the drawer
        if (!drawerState === false) {
            setUserBeingAdded(undefined);
            setCurrentFormStep(FormStepsEnum.initial);
            setSingleOrMulti(AddingUserOptions.single);
            setDelegationState();
            setErrorState(initialError);
            setStudyAccessLevel({
                user: undefined,
                access: undefined
            });
            props.setSelectedRow();
            setIsEditMode(false);
            setShowRemoveStudy(false);
            setShowRemoveStudyAudit(false);
            props.onDismiss();
        }
    };

    const handleOnDelegationDataSelected = (delegationState) => {
        setDelegationState(delegationState);
        let error = { ...errorState };
        if (errorState.dataSource)
            error.dataSource = !delegationState.datasource;
        if (errorState.role)
            error.role = !delegationState.role;

        setErrorState(error);
    };

    const handlePreviousStep = () => {
        setCurrentFormStep([FormStepsEnum.initial]);
    };
    const validate = () => {
        const { currentDOA } = props;
        const errors = [];
        verifyNoPITenuresOverlapped(
            currentDOA,
            delegationState.role.label,
            [delegationState.startDate, delegationState.endDate],
            () => errors.push('StartDate', 'EndDate')
        );

        if (lodash.isEmpty(errors)) {
            return true;
        }

        // stackAnErrorMessage(
        //     'This PI can\'t be added since their tenure conflicts with an existing PI\'s tenure. ' +
        //     'If you want to add this PI, their tenure will need to be modified.'
        // );
        setPISignationError(true);
        return false;
    };

    const handleAddUserFinish = async () => {
        // @TODO: we done!

        if (singleOrMulti == AddingUserOptions.multiple) {
            setLoading(true);
            await handleMultipleAddUser();
            setLoading(false);
            return false;
        }
        if (addUserValidation(delegationState)) {
            if (delegationState.role && (delegationState.startDate || delegationState.endDate)) {
                if (!validate()) {
                    return false;
                }
            }
            setLoading(true);
            const userDelegation = {
                sub: delegationState.selectedUser.user.sub,
                userId: delegationState.selectedUser.user.value,
                studyRoleId: delegationState.role && delegationState.role.value,
                studyRoleName: delegationState.role && delegationState.role.label,
                displayName: delegationState.selectedUser.user.label,
                ...((delegationState.userSelection === AddToDelegationLogOptions.now || delegationState.bindersDatasource === AddDocumentToBinderLogOptions.now) && delegationState.datasource && delegationState.datasource.value ? { nameOfResearcher: delegationState.datasource.value } : {})
            };
            let delegationData;
            const signatureExpectations = [];
            if (delegationState.userSelection == 'now' || userDelegation.studyRoleId) {
                const tasksList = delegationState.responsibilities.map((i) => i.task);
                const delegation = {
                    id: uuid.v4(),
                    startDate: delegationState.startDate && moment(delegationState.startDate).isValid() ? moment(delegationState.startDate).toISOString() : null,
                    endDate: delegationState.endDate && moment(delegationState.endDate).isValid() ? moment(delegationState.endDate).toISOString() : null,
                    user: {
                        id: userDelegation.userId,
                        name: userDelegation.displayName
                    },
                    tasks: tasksList,
                    roleManagementId: userDelegation.studyRoleId,
                    auditOrigin: 'Study Settings',
                    auditActivity: 'A corresponding delegation is created when a Study Team Member is added in Study Settings.'

                };
                const signatures = delegationState.signatureRequests ? delegationState.signatureRequests.map((d) => ({
                    delegationId: delegation.id,
                    user: {
                        id: d.data.userId,
                        name: d.data.label,
                    },
                    signatureType: d.data.role == 'P.I.' ? 'PI_START' : 'STAFF_START',
                })) : [];
                signatureExpectations.push(...signatures);

                if (!lodash.isEmpty(delegationRequiringNewPISignature)) {
                    const signaturesForExistingDelegation = lodash
                        .chain(delegationRequiringNewPISignature)
                        .filter(({ checked }) => checked)
                        .map((option) => ({
                            delegationId: lodash.get(option, 'data.id'),
                            user: {
                                id: userDelegation.userId,
                                name: userDelegation.displayName,
                            },
                            signatureType: 'PI_START',
                        }))
                        .value();
                    signatureExpectations.push(...signaturesForExistingDelegation);
                }
                delegationData = {
                    delegation,
                    signatureExpectations: signatureExpectations,
                    defaultSignatureExpectations: signatures,
                };
            }
            await props.createTeamMember(userDelegation, delegationState.selectedUser.access.value, delegationData, delegationState.userSelection == 'now', true);
            setLoading(false);

            props.onFilterUpdate();
            toggleDrawer();
        }
    };
    const addUserValidation = (delegationStateValue = delegationState) => {
        let error = initialError;
        if (studyAccessLevel && !studyAccessLevel.user) {
            error.user = !studyAccessLevel.user;
            error.access = !studyAccessLevel.access;
        }
        else if (delegationStateValue && delegationStateValue.selectedUser.access && delegationStateValue.selectedUser.access.value == STUDY_USER_TYPE.TEAM) {
            error.dataSource = !delegationStateValue.datasource;

            if (delegationStateValue.userSelection == 'now' || (props.selectedRow && !props.selectedRow.delegation)) {
                if (!isEditMode)
                    error.role = !delegationStateValue.role;
            }
        }
        else if (delegationStateValue && delegationStateValue.selectedUser.access && delegationStateValue.selectedUser.access.value != STUDY_USER_TYPE.TEAM && ((delegationStateValue.userSelection == 'now' || delegationStateValue.bindersDatasource == 'now'))) {
            error.dataSource = !delegationStateValue.datasource;
            if (delegationStateValue.userSelection == 'now' && (!props.selectedRow || (props.selectedRow && !props.selectedRow.delegation))) {
                if (!isEditMode)
                    error.role = !delegationStateValue.role;
            }
        }
        else {
            setErrorState(initialError);
            return true;
        }
        setErrorState(error);
        return !error.access && !error.dataSource && !error.role && !error.user;
    };
    const handleMultipleAddUser = async () => {
        if (!studyAccessLevel.users.length || !studyAccessLevel.access) {
            let error = initialError;
            if (!studyAccessLevel.users.length) {
                error.user = true;
            }

            if (!studyAccessLevel.access) {
                error.access = true;
            }
            setErrorState(error);
            return;
        }
        const selectGroupUsers = studyAccessLevel.users.filter(u => u.users);
        const selectUsers = studyAccessLevel.users.filter(u => !u.users && u.sub);
        let groupUsers = [];
        selectGroupUsers.forEach(g => {
            groupUsers = [...groupUsers, ...g.users];
        });
        let totalUsers = lodash.unionBy(selectUsers, groupUsers, 'value');
        const userToAdd = totalUsers.map((list) => ({
            institutionId: props.study.institutionId,
            userId: list.value,
            studyRoleId: '',
            nameOfResearcher: '',
            hasAdminRole: studyAccessLevel.access.value == STUDY_USER_TYPE.ADMIN,
            studyId: props.study.id,
            studyUserType: studyAccessLevel.access.value
        }));
        await props.addStudyTeamMember(userToAdd, studyAccessLevel.access.value, true);
        props.onFilterUpdate();
        toggleDrawer();
    };

    const handleOnUserAddOptionSelected = (selectValue) => {
        setSingleOrMulti(selectValue);
        setCurrentFormStep([FormStepsEnum.userAndAccess]);
    };

    /**
     * @param {{ user: *, access: *, users:* }} selectedValue 
     */
    const handleOnUserAndAccessSelected = (selectedValue) => {
        setStudyAccessLevel(selectedValue);
        let error = errorState;
        if (errorState.user)
            error.user = singleOrMulti == AddingUserOptions.single ? !selectedValue.user : !selectedValue.users;

        if (errorState.access)
            error.access = !selectedValue.access;

        setErrorState(error);
        if (selectedValue.user && selectedValue.access) {
            setCurrentFormStep([...currentFormStep, FormStepsEnum.delegationLog]);
            const doa = props.staffDescriptorOptions.find((doa => doa.label == selectedValue.user.label));
            if (doa)
                setDelegationState({ ...delegationState, datasource: doa });
            else if (!props.selectedRow)
                setDelegationState({ ...delegationState, datasource: null });
        }
    };

    /**
     * @param {{ user: *, access: * }} selectedValue 
     */
    const handleOnUserAndAccessSelectedEdit = (selectedValue) => {
        if (selectedValue.user && selectedValue.access) {
            setStudyAccessLevel(selectedValue);
            setSingleOrMulti('single');
            setCurrentFormStep([FormStepsEnum.userAndAccess, FormStepsEnum.delegationLog]);
        }
        let newDelegation = { ...delegationState };
        if (props.selectedRow.nameOfResearcher) {
            newDelegation.datasource = {
                value: props.selectedRow.nameOfResearcher,
                label: props.selectedRow.nameOfResearcher
            };
        }
        else {
            const doa = props.staffDescriptorOptions.find((doa => doa.label == selectedValue.user.label));
            newDelegation.datasource = doa;
        }
        if (props.selectedRow.selectedUser && props.selectedRow.selectedUser.studyRole) {
            newDelegation.role = {
                value: props.selectedRow.selectedUser.studyRole.id,
                label: props.selectedRow.selectedUser.studyRole.name
            };
        }
        setDelegationState(newDelegation);
    };
    /**
     * Display user name being added when possible.
     */
    const addToTeamTitle = () => {
        if (userBeingAdded) return userBeingAdded;
        return 'User';
    };

    const getAccessLevelsOptions = () => {
        const accessLevels = Object.keys(STUDY_TEAM_DESC).map(key => {
            return {
                label: STUDY_TEAM_CAPITAL_v2[key],
                value: STUDY_USER_TYPE[key]

            };
        });
        if (!props.canManageStudyAdmins) {
            return accessLevels.filter(s => s.value != 'admin');
        }
        return accessLevels;

    };

    const getUserListOption = (users) => {
        return users.map(user => (
            {
                value: user.userId,
                label: user.displayName,
                sub: user.sub,
                nameOfResearcher: user.nameOfResearcher || ''
            }
        ));
    };


    const handleOnEditSubmit = () => {
        if (!addUserValidation(delegationState))
            return;

        if (delegationState.role && (delegationState.startDate || delegationState.endDate)) {
            if (!validate()) return false;
        }

        if (delegationState.userSelection == 'now' && !delegationState.role && !isEditMode) {
            setErrorState({ ...errorState, role: true });
        }
        setLoading(true);
        const userID = selectedUser.userId;
        const currentStudyRoleId = lodash.get(selectedUser, 'studyRoleId', null);
        const nextStudyRoleId = studyAccessLevel.access.value === STUDY_USER_TYPE.ADMIN
            ? null
            : lodash.get(delegationState, 'role.value', null);

        const hasAddedStudyRole = !currentStudyRoleId && !!nextStudyRoleId;

        const hasChangeStudyRole = currentStudyRoleId !== nextStudyRoleId;

        const nameOfResearcherChanged = selectedUser.nameOfResearcher !== lodash.get(delegationState, 'datasource.value', undefined);
        const sortedDelegations = lodash.orderBy(props.doaStudyDelegations, (doa) => moment(doa.createdAt), ['desc']);
        const delegationRoleId = currentStudyRoleId || nextStudyRoleId;
        let dataUser = sortedDelegations.find(
            (doa) =>
                doa.user.id === userID &&
                doa.rolesManagement &&
                doa.rolesManagement.id === delegationRoleId
        );
        const selectedUserHasDelegations = dataUser ? true : false;
        const studyRoleSet = hasAddedStudyRole || hasChangeStudyRole;

        const responsibilitiesChanged = !lodash.isEqual(
            lodash.get(props.selectedRow, 'selectedUser.delegation.taskIds', []),
            (delegationState.responsibilities ? delegationState.responsibilities.map((i) => i.task.id) : [])
        );

        const isFullFields = delegationState && (
            !lodash.isNil(delegationState.startDate) &&
            !lodash.isEmpty(delegationState.selectedUser.user) &&
            !lodash.isNil(delegationState.role)
        );

        if (!studyRoleSet && !nameOfResearcherChanged && !responsibilitiesChanged && selectedUserHasDelegations && !isFullFields) {
            handleModifyStudyTeamMember();
            return;
        }
        const isStillStaff =
            lodash.get(props.selectedRow, 'delegation.rolesManagement.name', '') !== PI_ROLE &&
            lodash.get(delegationState, 'role.label', '') !== PI_ROLE;

        const isChangePIToStaff =
            lodash.get(props.selectedRow, 'delegation.rolesManagement.name', '') === PI_ROLE &&
            lodash.get(delegationState, 'role.label', '') !== PI_ROLE;

        const delegation = lodash.cloneDeep({
            binderId: props.study.binderId,
            id: (dataUser ? dataUser.id : uuid.v4()),
            studyId: props.study.id,
            user: {
                id: delegationState.selectedUser.user.value,
                name: delegationState.selectedUser.user.label,
            },
            tasks: (delegationState.responsibilities ? delegationState.responsibilities.map((i) => i.task) : []),
            startDate: delegationState.startDate && moment(delegationState.startDate).isValid() ? moment(delegationState.startDate).toISOString() : null,
            endDate: delegationState.endDate && moment(delegationState.endDate).isValid() ? moment(delegationState.endDate).toISOString() : null,
            notes: '',
            isRevokedPIRole: !isChangePIToStaff,
            isStillStaff,
            auditOrigin: 'Study Settings',
            auditActivity: 'Updating this Study Team Member’s role in Study Settings updates this user’s start date.'
        });

        const studyRoleId = nextStudyRoleId;
        if (studyRoleId) {
            delegation.roleManagementId = studyRoleId;
        }


        const signatureExpectations = [];
        if (isFullFields) {
            const allSignatureSuggested = delegationState.signatureRequests ? delegationState.signatureRequests.map((d) => ({
                delegationId: delegation.id,
                user: {
                    id: d.data.userId,
                    name: d.data.label,
                },
                signatureType: d.data.role == 'P.I.' ? 'PI_START' : 'STAFF_START',
            })) : [];
            signatureExpectations.push(...allSignatureSuggested);

            if (!lodash.isEmpty(delegationRequiringNewPISignature)) {
                const signaturesForExistingDelegation = lodash
                    .chain(delegationRequiringNewPISignature)
                    .filter(({ checked }) => checked)
                    .map((option) => ({
                        delegationId: lodash.get(option, 'data.id'),
                        user: {
                            id: delegationState.selectedUser.user.value,
                            name: delegationState.selectedUser.user.label,
                        },
                        signatureType: 'PI_START',
                    }))
                    .value();
                signatureExpectations.push(...signaturesForExistingDelegation);
            }
            handleModifyStudyTeamMember(delegation, allSignatureSuggested, signatureExpectations);
        } else {

            handleModifyStudyTeamMember(delegation, []);
        }
        setLoading(false);

    };

    const handleModifyStudyTeamMember = (delegation = {}, signatures = [], signatureExpectations = []) => {
        const studyRoleId = studyAccessLevel.access.value === STUDY_USER_TYPE.ADMIN
            ? null
            : lodash.get(delegationState, 'role.value', null);

        props.modifyStudyTeamMember({
            id: props.selectedRow.teamMemberId,
            studyUserType: studyAccessLevel.access.value,
            studyRoleId,
            hasAdminRole: studyAccessLevel.access.value == STUDY_USER_TYPE.ADMIN,
            userId: studyAccessLevel.user.value,
            displayName: studyAccessLevel.user.label,
            nameOfResearcher: delegationState.datasource && delegationState.datasource.value || ''
        }, {
            delegation,
            binderId: delegation && delegation.binderId,
            defaultSignatureExpectations: signatures,
            signatureExpectations: signatureExpectations,
            studyRoleId,
            studyRoleName: delegationState.role && delegationState.role.label,
        }, true, props.onFilterUpdate
        );
        setLoading(false);
        toggleDrawer();
    };
    const handleRemoveStudyTeam = async () => {
        if (selectedUser.studyRoleId || (selectedUser.delegation && selectedUser.delegation.rolesManagement.id)) {
            const userID = selectedUser.userId;
            const sortedDelegations = lodash.orderBy(props.doaStudyDelegations, (doa) => moment(doa.createdAt), ['desc']);
            const dataUser = sortedDelegations.find((doa) => (doa.user.id === userID) && (doa.rolesManagement && (doa.rolesManagement.id === selectedUser.studyRoleId || (selectedUser.delegation && doa.rolesManagement.id === selectedUser.delegation.rolesManagement.id))));
            const signatures = lodash.get(dataUser, 'signatures', []);
            const completedSignatures = signatures.filter((item) => item.signatureStatus === 'COMPLETED');
            if (completedSignatures.length) {
                setShowRemoveStudy(false);
                setShowRemoveStudyAudit(true);
                const isRequiredField = !!completedSignatures.length;
                setRequiredNote(isRequiredField);
                setEndDate(moment(dataUser.endDate || new Date()).format('YYYY-MM-DD'));
                return false;
            }
            else if (dataUser) {

                let delegation = lodash.cloneDeep({
                    binderId: props.study.binderId,
                    id: dataUser.id,
                    studyId: props.study.id,
                    user: {
                        id: dataUser.user.id,
                        name: dataUser.user.displayName,
                    },
                    tasks: props.doaStudyTasks.filter((task) => dataUser.taskIds.includes(task.id)),
                    startDate: convertToISOString(parseDateFormat(dataUser.startDate)),
                    endDate: convertToISOString(dataUser.endDate || new Date()),
                    notes: auditNote,
                    isRevokedPIRole: false,
                    isStillStaff: false,
                    auditOrigin: 'Study Settings',
                    auditActivity: 'Removing this Study Team Member in Study Settings updates this user’s end date.'
                });

                if (new Date(dataUser.startDate) >= new Date()) {
                    delegation.startDate = convertToISOString(parseDateFormat(moment().format('LL')));
                }

                // const isFullFields =
                //     !lodash.isNil(dataUser.startDate) &&
                //     !lodash.isEmpty(dataUser.user) &&
                //     !lodash.isEmpty(dataUser.taskIds) &&
                //     !lodash.isNil(dataUser.rolesManagement);

                // if (isFullFields) {
                //     const piSignatureSuggested = collectPISignatures(dataUser);
                //     const staffSignatureSuggested = collectStaffSignatures(dataUser);

                //     const allSignatureSuggested = isRequiredNote ? [] : [...piSignatureSuggested, ...staffSignatureSuggested];

                //     // This case default signatures & requested signatures the same
                //     await props.updateStudyDelegationV2(
                //         delegation.binderId,
                //         delegation,
                //         allSignatureSuggested,
                //         allSignatureSuggested,
                //         () => {
                //             setShowRemoveStudyAudit(false);
                //             setAuditNote('');
                //             // props.stackASuccessMessage(
                //             //     'This End Date on this user\'s Delegation record has been set to today.'
                //             // );

                //             if (selectedUser.hasAdminRole) {
                //                 lodash.unset(selectedUser, 'studyRole');
                //                 lodash.unset(selectedUser, 'studyRoleId');
                //                 props.editStudyTeamMember(selectedUser, 'admin', null, true);
                //                 return;
                //             }
                //             props.removeStudyTeamMember(selectedUser, true);

                //         },
                //         delegation.studyId
                //     );
                // } else 
                {
                    await props.updateStudyDelegationV2(
                        delegation.binderId,
                        delegation,
                        [],
                        [],
                        async () => {
                            setShowRemoveStudyAudit(false);
                            setAuditNote('');
                            // props.stackASuccessMessage(
                            //     'This End Date on this user\'s Delegation record has been set to today.'
                            // );

                            if (selectedUser.hasAdminRole) {
                                lodash.unset(selectedUser, 'studyRole');
                                lodash.unset(selectedUser, 'studyRoleId');
                                await props.editStudyTeamMember(selectedUser, 'admin', null, true);
                            }
                            await props.removeStudyTeamMember(selectedUser, true);
                        },
                        delegation.studyId
                    );
                }

                await props.deleteStudyDelegationV2(dataUser.id, props.study.binderId, props.study.id, false);
                props.onFilterUpdate();
                return false;
            }
        }
        let selectedUserData = {
            id: props.selectedRow.teamMemberId,
            sub: studyAccessLevel.user.sub,
            studyUserType: studyAccessLevel.access.value,
            hasAdminRole: studyAccessLevel.access.value == STUDY_USER_TYPE.ADMIN,
            userId: studyAccessLevel.user.value,
            displayName: studyAccessLevel.user.label,
            nameOfResearcher: delegationState.datasource && delegationState.datasource.value || '',
            user: {
                id: studyAccessLevel.user.value,
                sub: studyAccessLevel.user.sub,
                displayName: studyAccessLevel.user.label,
            }
        };
        await props.removeStudyTeamMember(selectedUserData, true, props.onFilterUpdate);

        setShowRemoveStudy(false);
    };
    const handleOnAuditNoteSave = async () => {
        if (showRemoveStudyAudit && selectedUser) {
            if (isRequiredNote && (auditNote == '' || !endDate)) {
                setErrorState({ ...errorState, auditNote: !auditNote, endDate: !endDate });
                return false;
            }
        }
        const userID = selectedUser.userId;
        const sortedDelegations = lodash.orderBy(props.doaStudyDelegations, (doa) => moment(doa.createdAt), ['desc']);
        const dataUser = sortedDelegations.find((doa) => (doa.user.id === userID) && (doa.rolesManagement && (doa.rolesManagement.id === selectedUser.studyRoleId || (selectedUser.delegation && doa.rolesManagement.id === selectedUser.delegation.rolesManagement.id))));
        const endDateValue = parseDateFormat(moment(endDate).format('LL'));

        let delegation = lodash.cloneDeep({
            binderId: props.study.binderId,
            id: dataUser.id,
            studyId: props.study.id,
            user: {
                id: dataUser.user.id,
                name: dataUser.user.displayName,
            },
            tasks: props.doaStudyTasks.filter((task) => dataUser.taskIds.includes(task.id)),
            startDate: convertToISOString(parseDateFormat(dataUser.startDate)),
            endDate: convertToISOString(endDateValue),
            notes: auditNote,
            isRevokedPIRole: false,
            isStillStaff: false,
            auditOrigin: 'Study Settings',
            auditActivity: 'Removing this Study Team Member in Study Settings updates this user’s end date.'
        });

        if (new Date(dataUser.startDate) >= new Date()) {
            delegation.startDate = convertToISOString(parseDateFormat(moment().format('LL')));
        }

        const isFullFields =
            !lodash.isNil(dataUser.startDate) &&
            !lodash.isEmpty(dataUser.user) &&
            !lodash.isEmpty(dataUser.taskIds) &&
            !lodash.isNil(dataUser.rolesManagement);

        if (isFullFields) {
            const piSignatureSuggested = collectPISignatures(dataUser);
            const staffSignatureSuggested = collectStaffSignatures(dataUser);

            const allSignatureSuggested = isRequiredNote ? [] : [...piSignatureSuggested, ...staffSignatureSuggested];

            // This case default signatures & requested signatures the same
            await props.updateStudyDelegationV2(
                delegation.binderId,
                delegation,
                allSignatureSuggested,
                allSignatureSuggested,
                async () => {
                    setShowRemoveStudyAudit(false);
                    setAuditNote('');
                    // props.stackASuccessMessage(
                    //     'This End Date on this user\'s Delegation record has been set to today.'
                    // );

                    if (selectedUser.hasAdminRole) {
                        lodash.unset(selectedUser, 'studyRole');
                        lodash.unset(selectedUser, 'studyRoleId');
                        await props.editStudyTeamMember(selectedUser, 'admin', null, true);
                    }
                    await props.removeStudyTeamMember(selectedUser, true);

                },
                delegation.studyId
            );
        } else {
            await props.updateStudyDelegationV2(
                delegation.binderId,
                delegation,
                [],
                [],
                async () => {
                    setShowRemoveStudyAudit(false);
                    setAuditNote('');
                    // props.stackASuccessMessage(
                    //     'This End Date on this user\'s Delegation record has been set to today.'
                    // );

                    if (selectedUser.hasAdminRole) {
                        lodash.unset(selectedUser, 'studyRole');
                        lodash.unset(selectedUser, 'studyRoleId');
                        await props.editStudyTeamMember(selectedUser, 'admin', null, true);
                    }
                    await props.removeStudyTeamMember(selectedUser, true);
                },
                delegation.studyId
            );
        }
        // Delete DOA if no signature is completed.
        if (!isRequiredNote) {
            await props.deleteStudyDelegationV2(dataUser.id, props.study.binderId, props.study.id, false);
        }
        props.onFilterUpdate();
    };
    const collectPISignatures = (dataUser) => {
        if (dataUser.rolesManagement.name === PI_ROLE) {
            return [
                {
                    user: {
                        name: dataUser.user.displayName,
                        id: dataUser.user.id,
                    },
                    signatureType: 'PI_START',
                    delegationId: dataUser.id,
                    studyId: props.study.id
                },
            ];
        }

        return lodash
            .chain(props.doaStudyDelegations)
            .filter(
                ({ rolesManagement, startDate, endDate, user }) =>
                    lodash.get(rolesManagement, 'name', '') === PI_ROLE &&
                    user.id !== dataUser.user.id &&
                    isPITenureOverlappingWithDelegation(
                        [startDate, endDate],
                        [dataUser.startDate, dataUser.endDate]
                    )
            )
            .map(({ user }) => ({
                user: {
                    name: user.displayName,
                    id: user.id,
                },
                signatureType: 'PI_START',
                delegationId: dataUser.id
            }))
            .value();
    };

    const collectStaffSignatures = (dataUser) => {
        if (props.doaMode === 'CENTRAL' || dataUser.rolesManagement.name === PI_ROLE) {
            return [];
        }

        return [
            {
                user: {
                    name: dataUser.user.displayName,
                    id: dataUser.user.id,
                },
                signatureType: 'STAFF_START',
                delegationId: dataUser.id,
                studyId: props.study.id
            },
        ];
    };
    const onClickRemove = () => {
        if (props.selectedRow.studyUserType === 'admin') {
            const adminUsers = props.allStudyTeam.filter(s => s.studyUserType === 'admin');
            if (adminUsers.length <= 1) {
                setShowAdminRemoveStudy(true);
                return false;
            }
        }
        setShowRemoveStudy(true);
    };
    return (
        <div className={styles.addUserModal} data-cy="add-user-modal--wrapper">
            {/* <SecuredAddTeamMemberButton /> */}
            <Drawer open={drawerState} anchor="right" onClose={toggleDrawer}
                style={{ width: '100px' }}
            >
                <div className={`${styles.addUserModalContainer} ${showRemoveStudy || showRemoveStudyAudit || showAdminRemoveStudy ? styles.marginAuto : ''}`} data-cy="add-user-modal--content">
                    <Conditional condition={!showRemoveStudy && !showRemoveStudyAudit && !showAdminRemoveStudy}>

                        <div className={styles.addUserModalHeader} data-cy="add-user-modal--header-wrapper">
                            <div className={styles.addUserModalHeaderContent}>
                                <div className={styles.addUserModalHeaderContentText} data-cy="add-user-modal--header-text">
                                    {isEditMode ? `Edit ${studyAccessLevel.user && studyAccessLevel.user.label}` : singleOrMulti == AddingUserOptions.single ? `Add ${addToTeamTitle()} to Team` : 'Add Multiple Users'}
                                </div>
                                <div data-cy="add-user-modal--header-close-icon" className={styles.addUserModalHeaderContentIcon} onClick={toggleDrawer} >
                                    <FontAwesomeIcon icon={faClose} />
                                </div>
                            </div>
                            <hr className={styles.divider} />
                        </div>
                        <div className={styles.addUserModalBody}>
                            <Conditional condition={currentFormStep.includes(FormStepsEnum.initial)}>
                                <SingleOrMultiUser
                                    defaultValue={singleOrMulti}
                                    onUserAddOptionSelected={handleOnUserAddOptionSelected}
                                />
                            </Conditional>
                            <Conditional condition={currentFormStep.includes(FormStepsEnum.userAndAccess)}>
                                <UserAndAccess
                                    accessLevel={getAccessLevelsOptions()}
                                    userList={getUserListOption(props.usersSelections)}
                                    multiUserList={props.multiUser}
                                    allUsers={getUserListOption(props.allUsers)}
                                    onSelected={handleOnUserAndAccessSelected}
                                    error={errorState}
                                    studyAccessLevel={studyAccessLevel}
                                    isEditMode={isEditMode}
                                    singleOrMulti={singleOrMulti}
                                    studyAdminCount={studyAdminCount}
                                    currentAccessLevel={currentAccessLevel}
                                />
                            </Conditional>
                            <Conditional condition={currentFormStep.includes(FormStepsEnum.delegationLog) && singleOrMulti == AddingUserOptions.single}>
                                <DelegationLog
                                    onSelected={handleOnDelegationDataSelected}
                                    staffDescriptorOptions={props.staffDescriptorOptions}
                                    defaultUserSelection='now'
                                    studyRolesOptions={props.studyRolesOptions}
                                    responsibilitiesOptions={props.responsibilitiesOptions}
                                    userList={getUserListOption(props.usersSelections)}
                                    selectedUser={studyAccessLevel}
                                    currentDOA={props.currentDOA}
                                    doaMode={props.doaMode}
                                    addApplicationMessage={props.addApplicationMessage}
                                    dataType={props.dataType}
                                    dataSource={props.dataSource}
                                    error={errorState}
                                    isEditMode={isEditMode}
                                    datasourceValue={delegationState && delegationState.datasource}
                                    selectedRow={props.selectedRow}
                                    role={delegationState && delegationState.role}
                                    delegationRequiringNewPISignature={delegationRequiringNewPISignature}
                                    setDelegationRequiringNewPiSignature={setDelegationRequiringNewPiSignature}
                                    PIsignatureError={PIsignatureError}
                                    setPISignationError={setPISignationError}
                                    {...props}
                                />
                            </Conditional>
                            {/* MANAGE DELEGATION */}
                            <Conditional condition={(isEditMode && props.selectedRow && props.selectedRow.delegation && props.canManageDelegation)}>
                                <Link className={styles.manageDelegation} to={`/study/${props.study.id}/delegation`} data-test-id="manageDelegationLink" color='#2057AD'>
                                    Manage Delegation <FontAwesomeIcon icon={faExternalLink} style={{ paddingLeft: '5px' }} />
                                </Link>
                            </Conditional>
                        </div>
                    </Conditional>

                    {/* REMOVE USER CONFIRMATION FOOTER */}
                    <Conditional condition={showRemoveStudy}>
                        <div className={styles.removeStudyUser}>
                            Are you sure you want to remove {studyAccessLevel && studyAccessLevel.user && studyAccessLevel.user.label} from this {props.complion4FlagEnabled ? 'Binder' : 'Study'}?
                            <div className={styles.removeStudyUserConfirmBtn}>
                                <Button
                                    variant="outlined"
                                    className={classes.secondaryConfirmationBtn}
                                    onClick={handleRemoveStudyTeam}
                                >
                                    Yes
                                </Button>
                                <Button
                                    variant="outlined"
                                    className={classes.secondaryConfirmationBtn}
                                    onClick={() => setShowRemoveStudy(false)}
                                >
                                    No
                                </Button>
                            </div>
                        </div>
                    </Conditional>
                    <Conditional condition={showAdminRemoveStudy}>
                        <div className={styles.removeStudyUser}>
                            To remove {studyAccessLevel && studyAccessLevel.user && studyAccessLevel.user.label}, you must assign another Admin user.
                            <div className={styles.removeStudyUserConfirmBtn}>
                                <Button
                                    variant="outlined"
                                    className={classes.secondaryConfirmationBtn}
                                    onClick={() => setShowAdminRemoveStudy(false)}
                                >
                                    Okay
                                </Button>
                            </div>
                        </div>
                    </Conditional>
                    <Conditional condition={showRemoveStudyAudit}>
                        <div className={styles.removeStudyUser}>
                            <div className={styles.removeStudyNote}>
                                Removing {studyAccessLevel && studyAccessLevel.user && studyAccessLevel.user.label} from this Study will also end their Delegation.
                                Please set a Delegation End Date and enter Audit Notes.
                            </div>
                            <Input
                                id="endDate"
                                title={'End Date'}
                                name='endDate'
                                value={endDate}
                                placeholder='DD MMM YYYY'
                                type='date'
                                required={isRequiredNote}
                                min={delegationState && delegationState.stateDate}
                                errorText='End Date cannot be earlier than Start Date'
                                isValid={() => !errorState.endDate}
                                withBorder={true}
                                data-cy='StudyUsersAddTeamForm-EndDate'
                                onBlur={(e) => setEndDate(e.target.value)}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                            <Input
                                title={'Audit Notes'}
                                required={isRequiredNote}
                                onChange={(e) => {
                                    setAuditNote(e.target.value);
                                    setErrorState({ ...errorState, auditNote: false });
                                }}
                                data-cy="Remove-study-user-audit-message"
                                type="textarea"
                                isValid={() => !errorState.auditNote}
                                onBlur={(e) => setAuditNote(e.target.value)}
                                withBorder={true}
                                errorText={'An audit note is required to end this Delegation.'}
                                submitClicked={errorState.auditNote}
                                value={auditNote}
                            />
                            <div className={styles.removeStudyUserConfirmBtn}>
                                <Button
                                    variant="outlined"
                                    className={classes.secondaryConfirmationBtn}
                                    onClick={handleOnAuditNoteSave}
                                    style={{ textTransform: 'none' }}
                                >
                                    Remove from {props.complion4FlagEnabled ? 'Binder' : 'Study'}
                                </Button>
                                <Button
                                    variant="outlined"
                                    className={classes.secondaryConfirmationBtn}
                                    onClick={() => setShowRemoveStudyAudit(false)}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </Conditional>
                </div>
                {/* FOOTER */}
                <Conditional condition={!showRemoveStudy && !showRemoveStudyAudit && !showAdminRemoveStudy}>
                    <Conditional condition={!currentFormStep.includes(FormStepsEnum.initial) && !isEditMode}>
                        <div className={styles.addUserModalFooter}>
                            <div className={styles.addUserModalFooterContent}>
                                <Conditional condition={currentFormStep !== FormStepsEnum.initial}>
                                    <Button variant="outlined" className={classes.secondaryBtn} onClick={handlePreviousStep}>Previous</Button>
                                </Conditional>


                                <Box display="flex" gap="10" data-cy="add-user-modal--next-and-previous-btns-group" className={styles.addUserModalFooterContent}>
                                    <Button
                                        variant="outlined"
                                        className={classes.secondaryBtn}
                                        onClick={toggleDrawer}
                                        data-cy="add-user-modal--cancel-btn"
                                    >
                                        Cancel
                                    </Button>
                                    <Conditional condition={currentFormStep !== FormStepsEnum.initial}>
                                        <Button
                                            variant="contained"
                                            className={classes.primaryBtn}
                                            bgcolor={loading ? BUTTON.BGCOLOR.GREY7 : BUTTON.BGCOLOR.ORANGE}
                                            color={BUTTON.COLOR.WHITE}
                                            disabled={loading}
                                            onClick={handleAddUserFinish}>
                                            {loading ?
                                                <div className={styles.spinner}>
                                                    <SpinnerMini className={styles.filled} />
                                                </div> :
                                                singleOrMulti == AddingUserOptions.single ? 'Add User' : 'Add Users'}

                                        </Button>
                                    </Conditional>
                                </Box>


                            </div>
                        </div>
                    </Conditional>
                    {/* EDIT FOOTER */}
                    <Conditional condition={isEditMode}>
                        <div className={styles.addUserModalFooter}>
                            <div className={styles.editFooter}>
                                <Button
                                    className={`${classes.removeBtn} custom-button`}
                                    style={{ outlineColor: '#CC3333', color: '#CC3333' }}
                                    onClick={() => onClickRemove()}
                                >
                                    <FontAwesomeIcon icon={faTrashCan} style={{ color: '#CC3333', paddingRight: '5px' }} />
                                    Remove from {props.complion4FlagEnabled ? 'Binder' : 'Study'}
                                </Button>
                                <div className={styles.editSave}>
                                    <Button
                                        variant="outlined"
                                        className={classes.secondaryBtn}
                                        onClick={toggleDrawer}
                                        data-cy="add-study-modal-remove-btn"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        className={classes.primaryBtn}
                                        bgcolor={loading ? BUTTON.BGCOLOR.GREY7 : BUTTON.BGCOLOR.ORANGE}
                                        color={BUTTON.COLOR.WHITE}
                                        onClick={handleOnEditSubmit}
                                        disabled={loading}
                                        data-cy="add-study-modal-edit-btn"
                                    >  {loading ?
                                            <div className={styles.spinner}>
                                                <SpinnerMini className={styles.filled} />
                                            </div> : 'Save'}</Button>
                                </div>
                            </div>
                        </div>
                    </Conditional>
                </Conditional>

            </Drawer >
        </div >
    );
}

const mapStateToProps = (state) => {
    const users = getTeamMemberSelection(state);
    const allUsers = getTeamMemberSelection(state);
    const multiUser = getMultiUserListOptions(state);
    const me = lodash.get(state, 'me', {});
    const study = lodash.get(state, 'study', null);
    const studyRoles = lodash.get(state, 'studySettings.studyRoles', []);
    const studyRolesOptions = studyRoles.map(role => (
        { value: role.id, label: role.name })
    );
    const currentDOA = delegationsList(state);

    const staffDescriptor = lodash.get(state, 'dataSourceEditor.values', []);
    const allUsersWithGroup = lodash.get(state, 'users', []);
    const dataSource = lodash.get(state, 'dataSourceEditor.dataSource', {});

    const dataType = lodash.get(state, 'studySettings.staffDescriptor.dataType', null);
    const allStudyTeam = lodash.get(state, 'studySettings.allStudyTeam', null);

    const dataSourceId = lodash.get(state, 'studySettings.staffDescriptor.dataSourceId', null);
    const staffDescriptorOptions = staffDescriptor.map(staffDescriptor => (
        { value: staffDescriptor.value, label: staffDescriptor.text, status: staffDescriptor.status })
    ).filter(staffDescriptor => staffDescriptor.status === 'active');

    const responsibilitiesOptions = getDelegationTaskOptions(state);
    const canManageStudyAdmins = manageAdminsPredicate(state);
    const canManageStudyUsers = manageStudyTeamMemberPredicate(state);
    const doaMode = lodash.get(me, 'isInstitutionCentralized') === 'true' ? 'CENTRAL' : 'STANDARD';
    const activePI = getActivePI(state);
    const doaStudyDelegations = lodash.get(state, 'doaStudyDelegations', []);
    const doaStudyTasks = lodash.get(state, 'doaStudyTasks', []);
    const institutionId = lodash.get(state, 'binder.layout.institutionId');

    const canAddDataSource = lodash.get(state, `me.institutionPermissions.${institutionId}.dataSources`, false);
    const canManageDelegation = manageStudyDelegationPredicate(state);
    const studyTeam = lodash.get(state, 'studySettings.studyTeam', []);
    const allStudyTeamMembers = lodash.get(state, 'studySettings.allStudyTeam', []);

    return {
        study,
        studyRolesOptions,
        responsibilitiesOptions,
        usersSelections: users,
        staffDescriptorOptions,
        canManageStudyAdmins,
        canManageStudyUsers,
        currentDOA,
        doaMode,
        dataType,
        dataSource,
        dataSourceId,
        activePI,
        doaStudyDelegations,
        doaStudyTasks,
        staffDescriptor,
        canAddDataSource,
        allStudyTeam,
        canManageDelegation,
        allUsersWithGroup,
        studyTeam,
        multiUser,
        allStudyTeamMembers,
        allUsers,
        complion4FlagEnabled: loadHomePageV4Access(state),
    };
};

const mapActionsToProps = {
    getTeamMembersByInstitution,
    createTeamMember,
    editStudyTeamMember,
    getStudyDescriptors,
    getStudyRoles,
    removeStudyTeamMember,
    unloadStudySettingsTeam,
    loadStudyTasksV2,
    loadStudyDelegationsV2,
    addApplicationMessage,
    loadDataSourceLog,
    loadDataSource,
    unloadDataSource,
    writeDataSourceValues,
    saveDataSource,
    modifyStudyTeamMember,
    updateStudyDelegationV2,
    deleteStudyDelegationV2,
    addStudyTeamMember,
    getAllUsers,
    loadExternalUsersForStudy

};

export default connect(mapStateToProps, mapActionsToProps)(AddUsersModal);
